module.exports = __webpack_public_path__ + "img/LogoWhite.87e69fcf.png";